export const CLIENT_ID =
  "1037852130544-doj679d9892mojvb8jvkbs5larlm410o.apps.googleusercontent.com";

// test
// export const CLIENT_ID =
//   "54469523455-hchun98i1gs8he1oteap826vvd040ciu.apps.googleusercontent.com";

export const ICONS_URL = "https://signature-icons-ma.s3.amazonaws.com";
